intra_module.directive('documentReader', function() {
	return {
		restrict:    'E',
		templateUrl: 'directives/widget/document-reader/template.html',
		controller:  'DocumentReaderCtrl',

		scope: {
			close_reader: '&closeCallback',
			file:         '='
		}
	};
});
